import React, { useState } from "react";
import { RealSavingsTab } from "./real-savings-tab";

import { Tabs, TabsList, TabsTrigger } from "app/components/ui/tabs";

export const RealSavings = () => {
  const [activeTab, setActiveTab] = useState("3gb");

  const handleTabChange = (val: string) => {
    setActiveTab(val);
  };

  return (
    <section className="pt-14 sm:pt-[5.5rem] md:pt-[7.5rem] lg:pt-[8.75rem] pb-[4.75rem] sm:pb-[6.75rem] md:pb-[8.75rem] lg:pb-[10.19rem]">
      <div className="text-center px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12 mb-6 sm:mb-9 md:mb-12 lg:mb-[3.75rem]">
        <h2 className="font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-snug md:leading-normal lg:leading-[5.25rem]">
          Real Savings for Platform Drivers
        </h2>
        <p className="text-[#1D1D1B] text-[0.925rem] sm:text-base lg:text-lg font-normal leading-[1.375rem] sm:leading-6 lg:leading-7">
          VLE Mobile plans start at just{" "}
          <span className="font-semibold">$25/month</span> with plans designed
          for every driving schedule.
        </p>
      </div>
      <Tabs
        defaultValue="3gb"
        value={activeTab}
        onValueChange={handleTabChange}
        className="w-full max-w-[84rem] mx-auto"
      >
        <div className="flex flex-col gap-3 justify-center items-center w-full lg:flex-row lg:justify-between sm:gap-4 lg:gap-6 px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12">
          <div className="text-center lg:text-left">
            <h4 className="text-[#1D1D1B] text-lg sm:text-xl lg:text-2xl font-semibold leading-[1.375rem] sm:leading-6 lg:leading-7">
              Money Saving Calculator
            </h4>
            <p className="text-[#1D1D1B] text-[0.925rem] sm:text-base lg:text-lg font-normal leading-5 sm:leading-6 md:leading-7">
              Choose your data plan
            </p>
          </div>
          <div className="w-[100vw] max-w-fit overflow-auto [&::-webkit-scrollbar]:hidden">
            <TabsList className="gap-1.5 sm:gap-2 lg:gap-2.5 h-11 md:h-12 lg:h-[3.375rem] px-5 lg:px-1 py-2">
              <TabsTrigger
                value="3gb"
                className="data-[state=active]:bg-[#FE4D01] w-[6.125rem] sm:w-[7.125rem] lg:w-[8.125rem] h-9 md:h-10 lg:h-[2.875rem] border border-[#E5E7EB] data-[state=active]:border-[#FE4D01] rounded-full text-[#1D1D1B] data-[state=active]:text-white text-center text-[0.825rem] sm:text-sm lg:text-base font-medium leading-[0.9rem] sm:leading-4"
              >
                3GB
              </TabsTrigger>
              <TabsTrigger
                value="5gb"
                className="data-[state=active]:bg-[#FE4D01] w-[6.125rem] sm:w-[7.125rem] lg:w-[8.125rem] h-9 md:h-10 lg:h-[2.875rem] border border-[#E5E7EB] data-[state=active]:border-[#FE4D01] rounded-full text-[#1D1D1B] data-[state=active]:text-white text-center text-[0.825rem] sm:text-sm lg:text-base font-medium leading-[0.9rem] sm:leading-4"
              >
                5GB
              </TabsTrigger>
              <TabsTrigger
                value="15gb"
                className="data-[state=active]:bg-[#FE4D01] w-[6.125rem] sm:w-[7.125rem] lg:w-[8.125rem] h-9 md:h-10 lg:h-[2.875rem] border border-[#E5E7EB] data-[state=active]:border-[#FE4D01] rounded-full text-[#1D1D1B] data-[state=active]:text-white text-center text-[0.825rem] sm:text-sm lg:text-base font-medium leading-[0.9rem] sm:leading-4"
              >
                15GB
              </TabsTrigger>
              <TabsTrigger
                value="unlimited"
                className="data-[state=active]:bg-[#FE4D01] w-[8.5rem] sm:w-[9.5rem] lg:w-[10.5rem] h-9 md:h-10 lg:h-[2.875rem] border border-[#E5E7EB] data-[state=active]:border-[#FE4D01] rounded-full text-[#1D1D1B] data-[state=active]:text-white text-center text-[0.825rem] sm:text-sm lg:text-base font-medium leading-[0.9rem] sm:leading-4"
              >
                Unlimited
              </TabsTrigger>
            </TabsList>
          </div>
        </div>
        <RealSavingsTab tab={activeTab} />
        <div className="relative flex justify-center items-center w-full px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12 pt-3 pb-5 sm:pt-4 lg:pt-5 sm:pb-7 lg:pb-9 before:absolute before:content-[''] before:left-0 before:bottom-0 before:w-full before:h-px before:bg-[linear-gradient(90deg,_transparent_0%,_#1D1D1B33_25%,_#1D1D1B33_75%,_transparent_100%)]">
          <span className="inline-block text-center text-[#1D1D1B]/50 text-[0.825rem] sm:text-sm md:text-[0.925rem] lg:text-base font-normal leading-5 sm:leading-6 lg:leading-7">
            *Comparison based on average prices from major carriers for similar
            features
          </span>
        </div>
      </Tabs>
    </section>
  );
};
